import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, resolveComponent as _resolveComponent } from "vue";
const _hoisted_1 = { key: 1 };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { class: "label" };
const _hoisted_4 = { class: "label mt-4" };
const _hoisted_5 = { class: "notes" };
const _hoisted_6 = {
    key: 0,
    class: "error"
};
const _hoisted_7 = { key: 1 };
const _hoisted_8 = { class: "mt-3 flex gap-3" };
import _ from "lodash";
import AuBreadcrumb from "@/components/extended/AuBreadcrumb.vue";
import AuButton from "@/components/extended/AuButton.vue";
import AuInput from "@/components/extended/AuInput.vue";
import AuSelect from "@/components/extended/AuSelect.vue";
import BigNumber from "bignumber.js";
import i18n from "@/localization/localization.js";
import ProgressLoader from "@/loaders/progress-bar";
import { checkAccess, scope } from "@/help/accessData";
import { computed, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
export default /*@__PURE__*/ _defineComponent({
    __name: 'StockWithdraw',
    props: {
        id: {
            type: Number,
            default: 0
        }
    },
    emits: ["update"],
    setup(__props, { emit: __emit }) {
        const t = (key) => i18n.global.t(key);
        const store = useStore();
        const router = useRouter();
        if (!checkAccess(scope.testRole)) {
            router.push({ name: "base" });
        }
        const props = __props;
        const emit = __emit;
        const breadcrumb = ref([
            { key: 0, name: i18n.global.t("router.pages.dashboard"), path: "/" },
            { key: 1, name: i18n.global.t("router.pages.briefcase"), path: "/my-assets" }
        ]);
        const auOwners = ref([]);
        const amount = ref("");
        const selectedTokenId = ref(props.id);
        const loading = ref(false);
        const error = ref("");
        const progress = ref(false);
        const isSuccess = ref(false);
        const optionsToken = computed(() => auOwners.value.map(item => ({ display: item?.mnemonicEng, value: item?.id })));
        const selectedOwner = computed(() => auOwners.value.find(item => item?.id == selectedTokenId.value));
        const available = computed(() => selectedOwner.value?.availableBalance ?? "0");
        const decimals = computed(() => selectedOwner.value?.decimals ?? 2);
        const mnemonic = computed(() => selectedOwner.value?.mnemonicEng);
        const checkInput = (el) => {
            const buf = el?.target?.value.match(`^\\d*.?\\d{0,${decimals.value}}$`);
            amount.value = buf === null ? "" : buf[0];
        };
        const getAvailableTokens = async () => {
            try {
                const resp1 = await store.dispatch("getTradeTokens");
                const tradeTokens = resp1.data?.tokens;
                const resp2 = await store.dispatch("getTradeBalance");
                const tradeBalance = (resp2?.data ?? []);
                for (const token of tradeTokens) {
                    const balance = tradeBalance.find(item => token.symbol === item.token);
                    if (balance) {
                        token.availableBalance = balance.availableBalance;
                    }
                }
                return tradeTokens;
            }
            catch (e) {
                console.error(e);
            }
            return [];
        };
        const createOwnersList = async () => {
            const tradeTokens = await getAvailableTokens();
            for (const exchange of tradeTokens) {
                const tokenInList = _.find(store.getters.tokens, item => _.toUpper(exchange.symbol) === _.toUpper(item?.mnemonicEng));
                if (tokenInList) {
                    tokenInList.availableBalance = exchange?.availableBalance ?? 0;
                    auOwners.value.push(tokenInList);
                }
            }
        };
        const checkAmount = () => {
            if (BigNumber(amount.value).isZero()) {
                error.value = i18n.global.t("stockExchange.errorZeroAmount");
                return false;
            }
            if (amount.value > available.value) {
                error.value = i18n.global.t("stockExchange.errorLowBalance");
                return false;
            }
            error.value = "";
            return true;
        };
        const exchangeWithdrawal = async () => {
            if (!checkAmount()) {
                return;
            }
            const amountDecimal = BigNumber(amount.value).multipliedBy(BigNumber(10).pow(decimals.value));
            const params = {
                token: mnemonic.value,
                sum: amountDecimal.toString(10)
            };
            progress.value = true;
            try {
                const resp = await store.dispatch("exchangeWithdrawal", params);
                if (resp.status === 267) {
                    error.value = resp.data?.error ?? resp.data?.message;
                }
                if (resp.status === 200) {
                    error.value = "";
                    isSuccess.value = true;
                }
            }
            catch (e) {
                const err = e;
                error.value = (err.response.data?.message || err.response.data?.detail) ?? "Unknown error";
            }
            progress.value = false;
        };
        const goToMyAsset = () => {
            emit("update");
            router.push({ name: "my assets" });
        };
        const systemSettings = store.getters.apiSystemSettings;
        const goToTradingPlatform = () => {
            window.open(systemSettings?.exchangeUrl, "_blank");
        };
        onMounted(async () => {
            loading.value = true;
            await createOwnersList();
            loading.value = false;
        });
        return (_ctx, _cache) => {
            const _component_Form = _resolveComponent("Form");
            return (loading.value)
                ? (_openBlock(), _createBlock(_unref(ProgressLoader), {
                    key: 0,
                    mode: "indeterminate",
                    color: "#5AC396",
                    size: "150px"
                }))
                : (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(AuBreadcrumb, { pages: breadcrumb.value }, null, 8, ["pages"]),
                    _createVNode(_component_Form, null, {
                        header: _withCtx(() => [
                            _createTextVNode(_toDisplayString(t("stockExchange.titleWithdraw")), 1)
                        ]),
                        default: _withCtx(() => [
                            (!isSuccess.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                    _createElementVNode("div", _hoisted_3, _toDisplayString(t("stockExchange.select")), 1),
                                    _createVNode(AuSelect, {
                                        value: selectedTokenId.value,
                                        options: optionsToken.value,
                                        onInput: _cache[0] || (_cache[0] = v => selectedTokenId.value = v)
                                    }, null, 8, ["value", "options"]),
                                    _createElementVNode("div", _hoisted_4, _toDisplayString(t("stockExchange.amount")), 1),
                                    _createVNode(AuInput, {
                                        modelValue: amount.value,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((amount).value = $event)),
                                        type: "Number",
                                        onInput: checkInput
                                    }, null, 8, ["modelValue"]),
                                    _createElementVNode("div", _hoisted_5, _toDisplayString(t("stockExchange.available")) + " " + _toDisplayString(available.value + " " + mnemonic.value), 1),
                                    (error.value.length > 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(error.value), 1))
                                        : _createCommentVNode("", true),
                                    _createVNode(AuButton, {
                                        type: "primary",
                                        width: "280px",
                                        center: "",
                                        "is-progress": progress.value,
                                        onClick: exchangeWithdrawal
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(t("stockExchange.withdraw")), 1)
                                        ]),
                                        _: 1
                                    }, 8, ["is-progress"])
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                    _createElementVNode("div", null, _toDisplayString(t("stockExchange.exchangeSuccess")), 1),
                                    _createElementVNode("div", null, _toDisplayString(t("stockExchange.successMessage")), 1),
                                    _createElementVNode("div", _hoisted_8, [
                                        _createVNode(AuButton, {
                                            type: "primary",
                                            onClick: goToMyAsset
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(t("stockExchange.againBtn")), 1)
                                            ]),
                                            _: 1
                                        }),
                                        _createVNode(AuButton, {
                                            type: "primary",
                                            onClick: goToTradingPlatform
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(t("stockExchange.goToPlatformBtn")), 1)
                                            ]),
                                            _: 1
                                        })
                                    ])
                                ]))
                        ]),
                        _: 1
                    })
                ]));
        };
    }
});
